<template lang="html">
  <poll-filling-layout>

    <poll-filling
      :is_authenticated="false"
      :is_preview="false"
      :slug="($route.params.slug) ? $route.params.slug : ''"
      :external_url="($route.params.poll_url) ? $route.params.poll_url : ''"
      :session_id="session_id"
      :language="$root.languages.current"
      type="subjects"
    ></poll-filling>

  </poll-filling-layout>
</template>

<script>
import pollFillingLayout from '../../layouts/PollFilling.vue';
import pollFilling from '../../components/poll-filling/poll-filling.vue';
import * as common_functions from '../../common_functions.js';

export default {
  name: 'TeacherPoll',
  components: {
    pollFillingLayout,
    pollFilling,
  },
  data() {
    return {
      session_id: window.session_id,
      authorised: !(/\/teacher\/poll/gi.test(this.$route.path)),
    };
  },
}
</script>
